<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="My Devices" />
            <MyDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import MyDevices from '../MyDevices/MyDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'MyDevicesPage',
    components: {
        MainHeader,
        PageTitle,
        MyDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>